// @flow
import React, { Component } from 'react';
import { PrimaryText, HeaderText } from '../../Typography.jsx';

import ProblemMedicationTable from '../progressNote/ProblemMedicationTable.jsx';
import ProblemInterventionTable from '../progressNote/ProblemInterventionTable.jsx';
import { Button } from '../../Buttons.jsx';

type Props = {
  closeModal: Function,
  problem: Object,
  problemIdToMeds: Object,
  problemIdToInterventions: Object,
  acute: boolean,
  chronic: boolean,
}

class ProblemTreatmentModal extends Component<Props> {
  handleCancel = () => {
    this.props.closeModal();
  }

  render() {
    const {
      problem, problemIdToMeds, problemIdToInterventions, acute, chronic,
    } = this.props;
    return (
      problem
      && <div>
        <HeaderText>Treatments for {problem.diagnosis || 'unknown diagnosis'}</HeaderText>
        <PrimaryText>Medications</PrimaryText>
        <ProblemMedicationTable
          problemId={problem._id}
          medications={problemIdToMeds[problem._id] || []}
          acute={acute}
          chronic={chronic}
        />
        <br />
        <PrimaryText>Interventions</PrimaryText>
        <ProblemInterventionTable
          problemId={problem._id}
          interventions={problemIdToInterventions[problem._id] || []}
          acute={acute}
          chronic={chronic}
        />
        <br />
        <Button onClick={this.handleCancel}>Close</Button>
      </div>
    );
  }
}

export default ProblemTreatmentModal;



// WEBPACK FOOTER //
// ./client/src/components/patientPages/problem/ProblemTreatmentModal.jsx